import { createSelector } from 'reselect';

import { chosenCourseLivePeriodsSelector } from '../../../reducers/selectors';

const courseAttendanceType = state => state.builder.ui.course?.attendance;
const periodOrder = state => state.builder.ui.period?.periodOrder;

const courseTypeSelector = createSelector(
  courseAttendanceType,
  periodOrder,
  chosenCourseLivePeriodsSelector,

  (courseAttendance, periodOrderNumber, periods) => {
    const { REACT_APP_ENABLE_UPCOMING_PERIODS: ENABLE_UPCOMING_PERIODS } = process.env;
    const enableUpcomingPeriods = ENABLE_UPCOMING_PERIODS === '1';
    let status = 'invalidCourse';
    if (periodOrderNumber === 1 || enableUpcomingPeriods) {
      status = courseAttendance === 'FullTime' ? 'fullTimeCourse' : 'notFullTimeCourse';
    }
    return status;
  },
);

export default courseTypeSelector;
